import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const QualityMonitoring = {
  getQualityMonitoringSetups(data) {
    return axios({
      method: 'POST',
      url: `${API_URL}/client_quality`,
      data,
    })
  },

  getQualityMonitoringSetupPlants(data) {
    return axios({
      method: 'POST',
      url: `${API_URL}/setup_quality`,
      data,
    })
  },

  setQualityMonitoringPlantsThreshold(data) {
    return axios({
      method: 'POST',
      url: `${API_URL}/plant_threshold`,
      data,
    })
  },
}

export default QualityMonitoring
